import { API, PublicAccessApprovalMode } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type EditKitPublicAccessInput = {
  spaceId: number;
  kitId: string;
  downloadsRestricted?: boolean;
  downloadsRestrictedApproveMode?: PublicAccessApprovalMode;
};

const [useUpdateKitPublicAccess, updateKitPublicAccess] = createAsyncAction(
  "kits/updatePublicAccess",
  async ({
    spaceId,
    kitId,
    downloadsRestricted,
    downloadsRestrictedApproveMode,
  }: EditKitPublicAccessInput) => {
    const data = {
      downloads_restricted: downloadsRestricted,
      downloads_restricted_approve_mode: downloadsRestrictedApproveMode,
    };
    Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);

    const res = await API.call<{ kit: string }>({
      endpoint: `kits/${spaceId}/${kitId}`,
      method: "PUT",
      data,
    });
    return { ...res, result: res.result.kit };
  }
);
export default useUpdateKitPublicAccess;
export { updateKitPublicAccess };
